<template>
  <router-view />
</template>

<script>
export default {
  methods: {},
  created(){}
}
</script>

<style>
#keep .v-navigation-drawer__border {
  display: none;
}
</style>
